module.exports = __webpack_public_path__ + "img/back-bottom-right2.cfa48cfb.png";